<template>
	<div :class="['assistant-message', message.role]">
		<div v-if="message.role === 'user'" class="assistant-query">{{ message.text }}</div>
		<div v-else class="assistant-reply">
			<div v-if="streaming && progress.length" class="assistant-meta" aria-live="polite">
				<span class="assistant-working" aria-hidden="true"></span>
				{{ progress[0] }}
			</div>
			<div v-else-if="message.tools.length" class="assistant-meta">
				<v-icon aria-hidden="true">mdi-check</v-icon>
				<span>{{ message.tools.join(", ") }}</span>
			</div>
			<div class="assistant-markdown" v-html="html"></div>
			<div v-if="message.truncated" class="assistant-truncated">{{ truncatedNote }}</div>
			<template v-for="(card, i) in message.cards">
				<SearchCard
					v-if="card.type === 'search'"
					:key="i"
					:card="card"
					:on-product-search="onProductSearch"
					@apply="$emit('apply-search', $event)"
				/>
				<AttachmentCard v-else-if="card.type === 'attachment'" :key="i" :card="card" />
				<div v-else-if="card.type === 'faq'" :key="i" class="assistant-card assistant-card-row">
					<v-icon small aria-hidden="true">mdi-help-circle-outline</v-icon>
					<span class="assistant-card-title">Frequently asked questions</span>
					<v-btn small text color="primary" class="assistant-card-action" to="/faq">Open</v-btn>
				</div>
			</template>
			<div
				v-if="suggestions.length"
				class="assistant-suggestions"
				role="group"
				aria-label="Suggested replies"
			>
				<button
					v-for="reply in suggestions"
					:key="reply"
					type="button"
					class="assistant-suggestion"
					:aria-label="`Send: ${reply}`"
					@click="$emit('suggest', reply)"
				>
					{{ reply }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import SearchCard from "./SearchCard.vue";
import AttachmentCard from "./AttachmentCard.vue";
import { renderAssistantMarkdown } from "@/utils/assistantMarkdown";

export default {
	name: "AssistantMessage",
	components: { SearchCard, AttachmentCard },
	props: {
		message: { type: Object, required: true },
		streaming: { type: Boolean, default: false },
		progress: { type: Array, default: () => [] },
		onProductSearch: { type: Boolean, default: false },
		// The drawer allows the chips on the latest assistant message only, never while streaming or read-only.
		showSuggestions: { type: Boolean, default: false },
	},
	computed: {
		html() {
			return renderAssistantMarkdown(this.message.text);
		},
		suggestions() {
			return this.showSuggestions && this.message.suggestions ? this.message.suggestions : [];
		},
		truncatedNote() {
			if (!this.message.stopped) return "Answer cut short.";
			return this.message.text ? "Stopped." : "Stopped before the answer started.";
		},
	},
};
</script>
